// assets
import thumbStudio from "@images/Lookbook/thumbnails/studio-to-sea.webp"
import thumbIsland from "@images/Lookbook/thumbnails/island-life.webp"
import thumbCaramel from "@images/Lookbook/thumbnails/caramel-eyelet.webp"

export const lookbooks = [
	{
		title: "Caramel Eyelet",
		subTitle: "A delectable summer treat",
		buttonLabel: "Caramel Eyelet",
		image: thumbCaramel,
		link: "/lookbooks/caramel-eyelet",
	},
	{
		title: "Island Life",
		subTitle: "The Ashley & Kelly Edit",
		buttonLabel: "Island Life",
		image: thumbIsland,
		link: "/lookbooks/the-ashley-kelly-island-life",
	},
	{
		title: "Studio to Sea",
		subTitle: "Swim that moves with you, wherever your day goes.",
		buttonLabel: "Studio to Sea",
		image: thumbStudio,
		link: "/lookbooks/studio-to-sea",
	},

]
